import React, { MouseEventHandler } from 'react'
import Icon from './Icon'

type Props = {
    onClick?: MouseEventHandler<HTMLSpanElement>
}
export default function CloseIcon({ onClick }: Props) {
    return <Icon onClick={onClick} icon={'fas fa-times'} />
}
